import { Action, createReducer, on } from '@ngrx/store';
import { User } from '../../../core/models/user.model';

import * as fromUserActions from './user.actions';

export const userFeatureKey = 'userContext';

export interface UserState {
	user: User;
	userList: any;
	loadingUser: boolean;
	loadingUsers: boolean;
}

export const initialState: UserState = {
	user: null,
	userList: null,
	loadingUser: true,
	loadingUsers: true,
};

export const reducer = createReducer(
	initialState,
	on(fromUserActions.doLoadUserSuccess, (state, { user }) => ({
		...state,
		user,
		loadingUser: false,
	})),
	on(
		fromUserActions.doLoadUsersSuperSuccess,
		fromUserActions.doLoadUsersStandardSuccess,
		(state, { users }) => ({
			...state,
			userList: users,
			loadingUsers: false,
		})
	)
);

export function userReducer(state: UserState, action: Action): UserState {
	return reducer(state, action);
}
